<template>
  <v-app>
    <v-navigation-drawer app v-model="drawer" fixed clipped>
      <v-layout column fill-height>
        <v-list>
          <v-list-tile avatar :to="'/login'" >

            <v-list-tile-avatar v-if="user.displayName">
              <img :src="user.photoURL" >
            </v-list-tile-avatar>

            <v-list-tile-avatar v-else>
              <!-- <img src="https://randomuser.me/api/portraits/lego/1.jpg"> -->
              <v-avatar>
                <v-icon>account_circle</v-icon>
              </v-avatar>
            </v-list-tile-avatar>

            <v-list-tile-content>
              <v-list-tile-title>
                {{ !user.displayName ? 'Login' : user.displayName }}
              </v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>

          <!-- Menu parser -->
          <v-list-tile v-for="(item, key) in menu" v-if="userIsSignedIn && item.requiresAuth" :key="key" :to="item.action">
            <v-list-tile-action>
              <v-icon>{{item.icon}}</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>{{item.name}}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>

          <v-list-tile v-else-if="!item.requiresAuth" :key="key" :to="item.action">
            <v-list-tile-action>
              <v-icon>{{item.icon}}</v-icon>
            </v-list-tile-action>

            <v-list-tile-content>
              <v-list-tile-title>{{item.name}}</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>

          <template v-if="userIsSignedIn">

            <!-- Events -->
            <v-list-group prepend-icon="event" no-action>
              <!-- Menu Item Dropdown Activator-->
              <v-list-tile slot="activator">
                <v-list-tile-content>
                  Events
                </v-list-tile-content>
              </v-list-tile>
              <!-- Dropdown Items -->
              <!-- Owner's events -->
              <v-list-tile v-for="event in allEvents" :key="event.id" :to="'/event/'+event.id">
                <v-list-tile-content>
                  <v-list-tile-title>{{event.name}}</v-list-tile-title>
                </v-list-tile-content>
                <v-list-tile-action>
                  <v-icon>edit</v-icon>
                </v-list-tile-action>
              </v-list-tile>
              <!-- Dropdown Items -->
              <!-- Share events -->
              <v-list-tile v-for="event in sharedEvents" :key="event.id" :to="'/event/'+event.id">
                <v-list-tile-content>
                  <v-list-tile-title>{{event.name}}</v-list-tile-title>
                </v-list-tile-content>
                
                <v-list-tile-action>
                  <v-icon>group</v-icon>
                </v-list-tile-action>
              </v-list-tile>
              <!-- Create new event -->
              <v-list-tile to="/event">
                <v-list-tile-action>
                  <v-icon>add</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>New Event</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>    
            </v-list-group>

            <!-- Favorite Locations -->
            <v-list-group prepend-icon="location_on" no-action>
              <!-- Dropdown Menu Item -->
              <v-list-tile slot="activator">
                <v-list-tile-content>
                  Locations
                </v-list-tile-content>
              </v-list-tile>
              <!-- Dropdown Sub-Items -->

              <!-- Locations Map -->
              <v-list-tile :to="'/locations'">
                <v-list-tile-content>
                  <v-list-tile-title>All Locations</v-list-tile-title>
                </v-list-tile-content>
                <v-list-tile-action>
                  <v-btn icon>
                    <v-icon>map</v-icon>
                  </v-btn>
                </v-list-tile-action>
              </v-list-tile>

              <!-- Edit Locations -->
              <v-list-tile v-for="location in allLocations" :key="location['.key']" :to="'/location/'+location.id">
                <v-list-tile-content>
                  <v-list-tile-title>{{location.title ? location.title : location.name}}</v-list-tile-title>
                </v-list-tile-content>
                <v-list-tile-action>
                  <v-btn icon>
                    <v-icon>edit_location</v-icon>
                  </v-btn>
                </v-list-tile-action>
              </v-list-tile>

              <!-- Create new Location -->
              <v-list-tile to="/location/new">
                <v-list-tile-action>
                  <v-icon>add</v-icon>
                </v-list-tile-action>
                <v-list-tile-content>
                  <v-list-tile-title>New Location</v-list-tile-title>
                </v-list-tile-content>
              </v-list-tile>
            </v-list-group>
          </template>

          <!-- Settings -->
          <v-list-tile v-if="userIsSignedIn" @click="settingsDialog = true">
            <v-list-tile-action>
              <v-icon>settings</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Settings</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>

          <!-- Sign Out -->
          <v-list-tile v-if="userIsSignedIn"  @click="firebasesignout()">
            <v-list-tile-action>
              <v-icon>exit_to_app</v-icon>
            </v-list-tile-action>
            <v-list-tile-content>
              <v-list-tile-title>Sign Out</v-list-tile-title>
            </v-list-tile-content>
          </v-list-tile>
            
        </v-list>
      </v-layout>
    </v-navigation-drawer>

    <v-toolbar app clipped-left scroll-toolbar-off-screen flat dark color="primary">
      <v-toolbar-side-icon @click.stop="drawer = !drawer"></v-toolbar-side-icon>
      <v-toolbar-title>ZoomRyde</v-toolbar-title>
      <v-spacer></v-spacer>
      <v-btn icon @click="settingsDialog = true">
        <v-icon>settings</v-icon>
      </v-btn>
    </v-toolbar>
    
    <v-content>
      <v-container fill-height fluid pa-0>
        <router-view></router-view>
      </v-container>
    </v-content>

    <v-layout row justify-center>
      <v-dialog
        v-model="settingsDialog"
        :fullscreen="$vuetify.breakpoint.smAndDown" hide-overlay 
        :transition="$vuetify.breakpoint.smAndDown ? 'dialog-bottom-transition' : 'dialog-transition'"
        :max-width="$vuetify.breakpoint.smAndDown ? '' : '600px'"
      >
        <v-card>
          <v-toolbar dark color="secondary">
            <v-btn icon dark @click="settingsDialog = false">
              <v-icon>close</v-icon>
            </v-btn>
            <v-toolbar-title>Settings</v-toolbar-title>
            <v-spacer></v-spacer>
            <v-toolbar-items>
              <v-btn dark flat @click="saveSettings">Save</v-btn>
            </v-toolbar-items>
          </v-toolbar>
          <v-list three-line subheader>
            <v-subheader>Ryde Settings</v-subheader>
            
            <v-list-tile avatar>
              <v-list-tile-action>
                <v-checkbox v-model="settings.esp"></v-checkbox>
              </v-list-tile-action>

              <v-list-tile-content>
                <v-list-tile-title>Español</v-list-tile-title>
                <v-list-tile-sub-title>View options where the primary language is Spanish.</v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>

            <v-list-tile avatar>
              <v-list-tile-action>
                <v-checkbox v-model="settings.lux"></v-checkbox>
              </v-list-tile-action>

              <v-list-tile-content>
                <v-list-tile-title>Luxury</v-list-tile-title>
                <v-list-tile-sub-title>View options where the ryde is luxury vehicle.</v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>

            <v-list-tile avatar>
              <v-list-tile-action>
                <v-checkbox v-model="settings.cpl"></v-checkbox>
              </v-list-tile-action>

              <v-list-tile-content>
                <v-list-tile-title>Carpool</v-list-tile-title>
                <v-list-tile-sub-title>View options where you'll be sharing a vehicle with other ryders.</v-list-tile-sub-title>
              </v-list-tile-content>
            </v-list-tile>
          </v-list>
          <v-divider></v-divider>
          <v-list three-line subheader pr-0>
            <v-subheader>Theme</v-subheader>
          </v-list>

          <v-item-group mandatory v-model="selectedTheme" active-class="grey lighten-2 elevation-1">
            <v-container px-0>
              <v-layout row wrap justify-center px-0>
                <v-flex xs10 v-for="theme in themes" :key="theme.name" py-3>
                  <v-item>
                    <v-card flat slot-scope="{ active, toggle }" :color="active ? 'grey lighten-2' : 'grey lighten-4'" :class="`elevation-${ active ? 1 : 3}`" @click.native="toggle">
                      <v-layout row>
                        <v-flex xs12>
                          <v-subheader>{{theme.name}}</v-subheader>
                        </v-flex>
                      </v-layout>
                      <v-layout row align-center justify-space-around text-xs-center>
                        <v-flex>
                          <v-avatar :color="theme.primary"></v-avatar>
                          <div>Primary</div>
                        </v-flex>
                        <v-flex>
                          <v-avatar :color="theme.secondary"></v-avatar>
                          <div>Secondary</div>
                        </v-flex>
                        <v-flex>
                          <v-avatar :color="theme.accent"></v-avatar>
                          <div>Accent</div>
                        </v-flex>
                      </v-layout>
                    </v-card>
                  </v-item>
                </v-flex>
              </v-layout>
            </v-container>
          </v-item-group>

        </v-card>  
      </v-dialog>
    </v-layout>

    <v-snackbar 
      v-model="snackbar.show" top
      :color="snackbar.color" 
      :timeout="snackbar.timeout" 
      v-on:snackAlert="handleSnackAlert($event)">
      {{ snackbar.text }}
      <v-btn dark flat @click="closeSnackAlert()">
        Close
      </v-btn>
    </v-snackbar>

    <v-bottom-nav app dark fixed color="primary" :value="$vuetify.breakpoint.smAndDown">
      <v-btn flat to="/dashboard">
        <span>Events</span>
        <v-icon>event</v-icon>
      </v-btn>
      <v-btn flat to="/">
        <span>Home</span>
        <v-icon>home</v-icon>
      </v-btn>
      <v-btn flat to="/locations">
        <span>Locations</span>
        <v-icon>maps</v-icon>
      </v-btn>
    </v-bottom-nav>

  </v-app>
</template>

<script>
  //Required for authenticating users
  const fb = require('./firebaseConfig.js');

  import { eventBus } from './main'

  //Access to the vuex store

  import { mapState } from 'vuex'

  export default {
    name: 'app', 
    data: () => ({
      drawer: false, 
      user: {},
      menu: [
        {
          name: 'Dashboard',
          icon: 'dashboard', 
          requiresAuth: true,
          action: '/dashboard'
        },
        {
          name: 'Home', 
          icon: 'home', 
          action: '/'
        }
      ], 
      snackbar: {
        show: false, 
        text: '',
        color: '', 
        timeout: 3000
      },
      settingsDialog: false,
      settings: {
        esp: true,
        cpl: true,
        lux: true,
        theme: {
          name: 'Cloudy Mornings', 
          primary: '#9E9E9E',
          secondary: '#757575',
          accent: '#42A5F5'
        },
      }, 
      themes: [
        {
          name: 'Beach Sunset', 
          primary: '#FE6779',
          secondary: '#FFA285',
          accent: '#428AE0'
        },
        {
          name: 'Purple Mountains', 
          primary: '#4C3F77',
          secondary: '#7C587F',
          accent: '#007F97'
        },
        {
          name: 'Cloudy Mornings', 
          primary: '#9E9E9E',
          secondary: '#757575',
          accent: '#42A5F5'
        },
        {
          name: 'Sunny Day', 
          primary: '#00BCD4',
          secondary: '#4DD0E1',
          accent: '#FDD835'
        },
      ], 
      selectedTheme: null, 
      location: {}
    }), 
    mounted: function() {
      this.geolocate( (location) => {
        eventBus.$emit('geolocated', {lat: location.lat, lng: location.lng });
      });
    },
    computed: {
      ...mapState({
        signedInUser: state => state.users.currentUser, 
        allEvents:    state => state.events.allEvents, 
        sharedEvents: state => state.events.sharedEvents,
        allLocations: state => state.locations.locations, 
        userSettings: state => state.users.settings,
      }), 
      userIsSignedIn: function() {
        //Should call a firebase get to pull user from store
        return !(Object.keys(this.user).length === 0);
      }
    },
    watch: {
      userSettings: function(newUserSettings, oldUserSettings){
        if(typeof newUserSettings == 'object'){
          this.settings = newUserSettings;
          this.selectedTheme = (this.themes.findIndex(x => x.name == this.settings.theme.name));

          let updatedTheme = this.themes[this.selectedTheme];

          this.$vuetify.theme.primary = updatedTheme.primary;
          this.$vuetify.theme.secondary = updatedTheme.secondary;
          this.$vuetify.theme.accent = updatedTheme.accent;
        }
      }, 
      selectedTheme(newThemeIndex, oldThemeIndex){
        if(typeof newThemeIndex == 'number'){
          let theme = this.themes[newThemeIndex];

          this.$vuetify.theme.primary = theme.primary;
          this.$vuetify.theme.secondary = theme.secondary;
          this.$vuetify.theme.accent = theme.accent;
        }
      }
    },
    methods: {
      firebasesignout: function() {
        this.$store.dispatch('users/logout');
        this.$router.go('/');
      }, 
      handleSnackAlert(alert){
        this.snackbar.text = alert.text;
        this.snackbar.color = alert.color;
        this.snackbar.show = true;
      },
      /**
      * @param location = {lat: value, lng: value}
      */
      handleLocationUpdate(location){
        this.location = location
      },
      closeSnackAlert(){
        this.snackbar.show = false;
        this.snackbar.text = '';
        this.snackbar.color = '';
      },
      saveSettings(){
        this.settings.theme = this.themes[this.selectedTheme];
        this.$store.dispatch('users/saveSettings', this.settings);
        this.snackbar.text = 'Your settings have been saved!';
        this.snackbar.color = 'success'

        eventBus.$emit('snackAlert', this.snackbar);

        this.settingsDialog = false;
      }, 
      geolocate(callback = null){
        if (navigator.geolocation) {
          var options = {enableHighAccuracy: true};

          navigator.geolocation.getCurrentPosition(position => {
              let locationInformation = {
                  lat: position.coords.latitude,
                  lng: position.coords.longitude, 
                  accuracy: position.coords.accuracy
              };

              if (callback) callback(locationInformation);
          }, err => {
            this.$emit('error', 'Cannot get Coordinates from navigator', err);
          }, options);
        }
      }, 
    }, 
    beforeCreate: function() {
      fb.auth.onAuthStateChanged((user) => {
        if(user){
          this.user = user;

          fb.auth.currentUser.getIdTokenResult()
            .then((idTokenResult) => {
              if(!!idTokenResult.claims.admin){
                let userData = {
                  uid: user.uid,
                  email: user.email,
                  displayName: user.displayName,
                  admin: true
                };
                this.$store.commit('users/SET_USER', userData);
                this.$store.dispatch('users/getUserSettings');
                this.$store.dispatch('events/getEvents');
                this.$store.dispatch('events/getSharedEvents');
                this.$store.dispatch('locations/getLocations');
              } else {
                this.$store.commit('users/SET_USER', user);
                this.$store.dispatch('users/getUserSettings');
                this.$store.dispatch('events/getEvents');
                this.$store.dispatch('events/getSharedEvents');
                this.$store.dispatch('locations/getLocations');
              }
            })
        }
      })
    }, 
    created: function() {
      eventBus.$on('snackAlert', alert => {
        this.handleSnackAlert(alert);
      });

      eventBus.$on('geolocated', location => {
        this.handleLocationUpdate(location);
      });
    }
  } 
</script>

<style>

</style>
